(() => {
  'use strict';

  const SWIPER_SECTION_PARTS = [
    '__featured_collection_airgrix_97PGYL', // Daily Deals
    '__featured_collection_airgrix_hhEq4W', // Best Sellers
  ];
  const CLEARANCE_SECTION_PART = '__featured_collection_bALB4m';

  const getSection = (idPart) =>
    document.querySelector(`[id^="shopify-section-"][id*="${idPart}"]`);

  const makeButton = (label, glyph, className, controlsId) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `airgrix-home-carousel-button ${className}`;
    button.setAttribute('aria-label', label);
    if (controlsId) button.setAttribute('aria-controls', controlsId);
    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = glyph;
    button.append(icon);
    return button;
  };

  function setupSwiperCarousel(section) {
    const viewport = section?.querySelector('.swiper-container[id^="Slider-"]');
    const swiper = viewport?.swiper;
    if (!viewport || !swiper) return false;
    if (viewport.dataset.airgrixHomeCarouselReady === 'true') return true;

    // The theme already initializes Swiper. Make its intended manual interaction explicit.
    swiper.allowTouchMove = true;
    swiper.params.allowTouchMove = true;
    swiper.params.simulateTouch = true;
    swiper.params.grabCursor = true;
    if (typeof swiper.setGrabCursor === 'function') swiper.setGrabCursor();

    // The original section conditionally starts 5-second autoplay. Keep these rows user-controlled.
    const stopAutoplay = () => {
      if (swiper.autoplay?.running) swiper.autoplay.stop();
      if (swiper.params) swiper.params.autoplay = false;
      if (swiper.originalParams) swiper.originalParams.autoplay = false;
      if (swiper.passedParams) swiper.passedParams.autoplay = false;
    };
    stopAutoplay();
    swiper.on('breakpoint', stopAutoplay);

    viewport.classList.add('airgrix-home-swiper');
    const controls = document.createElement('div');
    controls.className = 'airgrix-home-carousel-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Product carousel controls');

    const previous = makeButton('Previous products', '‹', 'airgrix-home-carousel-button--prev', viewport.id);
    const next = makeButton('Next products', '›', 'airgrix-home-carousel-button--next', viewport.id);
    controls.append(previous, next);
    viewport.append(controls);

    previous.addEventListener('click', () => swiper.slidePrev());
    next.addEventListener('click', () => swiper.slideNext());

    const updateControls = () => {
      const visibleSlides = Number(swiper.params.slidesPerView) || 1;
      const canMove = swiper.slides.length > visibleSlides && !swiper.isLocked;
      controls.hidden = !canMove;
      previous.disabled = Boolean(swiper.isBeginning);
      next.disabled = Boolean(swiper.isEnd);
    };

    ['slideChange', 'update', 'resize', 'reachEnd', 'reachBeginning', 'fromEdge'].forEach((eventName) => {
      swiper.on(eventName, updateControls);
    });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
    viewport.dataset.airgrixHomeCarouselReady = 'true';
    return true;
  }

  function setupClearanceMouseDrag() {
    const section = getSection(CLEARANCE_SECTION_PART);
    const track = section?.querySelector('slider-component ul[id^="Slider-"]');
    if (!track) return false;
    if (track.dataset.airgrixPointerDragReady === 'true') return true;

    track.classList.add('airgrix-mouse-drag-track');
    let activePointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    let suppressClickUntil = 0;

    track.addEventListener('dragstart', (event) => event.preventDefault());

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      didDrag = false;
    });

    track.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerId !== activePointerId) return;
        const deltaX = event.clientX - startX;
        if (!didDrag && Math.abs(deltaX) > 6) {
          didDrag = true;
          track.classList.add('is-airgrix-pointer-dragging');
          if (typeof track.setPointerCapture === 'function') {
            track.setPointerCapture(activePointerId);
          }
        }
        if (!didDrag) return;
        track.scrollLeft = startScrollLeft - deltaX;
        if (event.cancelable) event.preventDefault();
      },
      { passive: false }
    );

    const finishDrag = (event) => {
      if (event.pointerId !== activePointerId) return;
      if (didDrag) suppressClickUntil = performance.now() + 400;
      activePointerId = null;
      track.classList.remove('is-airgrix-pointer-dragging');
    };

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener(
      'click',
      (event) => {
        if (performance.now() > suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        suppressClickUntil = 0;
      },
      true
    );

    track.dataset.airgrixPointerDragReady = 'true';
    return true;
  }

  function initialize() {
    let swiperReady = true;
    SWIPER_SECTION_PARTS.forEach((idPart) => {
      const section = getSection(idPart);
      if (!section || !setupSwiperCarousel(section)) swiperReady = false;
    });
    setupClearanceMouseDrag();
    return swiperReady;
  }

  initialize();
  let attempts = 0;
  const retryTimer = window.setInterval(() => {
    attempts += 1;
    if (initialize() || attempts >= 50) window.clearInterval(retryTimer);
  }, 100);

  document.addEventListener('shopify:section:load', () => window.setTimeout(initialize, 0));
})();
